'use strict';
import { action } from 'mobx';
import { fetch } from '@/lib/fetchAPI';

class DeviceInfoControlStore {
  @action
  postControl(deviceId, type) {
    let urlpara;
    if (type === 'reboot') {
      urlpara = 'device';
    } else {
      urlpara = 'device/report';
    }
    return fetch(
      `/api/${urlpara}/${type}?device_id=${deviceId}`,
      { method: 'POST' },
      json => json
    );
  }
}

export default new DeviceInfoControlStore();



// WEBPACK FOOTER //
// ./src/store/DeviceInfo/DeviceControl.js